import classNames from "classnames";
import React from "react";
import Avatar from "../Avatar";
import GigIcon from "../Icons/GigIcon";

const GroupAvatarsComponent = ({
  imgSrcSet = [],
  limit,
  total,
  dimensions,
  className = "pr-4",
  avatarClass = "",
  direction = "",
  showGigIcon = false,
  labelClassName,
}) => {
  let srcSet;
  if (typeof imgSrcSet === "string" || imgSrcSet instanceof String) {
    srcSet = [imgSrcSet];
  } else if (Array.isArray(imgSrcSet)) {
    srcSet =
      limit && imgSrcSet.length >= limit
        ? imgSrcSet.slice(0, limit)
        : imgSrcSet;
  } else {
    srcSet = [];
  }

  const directionClass = classNames({
    "flex-row": direction === "row",
    "flex-row-reverse": direction === "row-reverse",
    "flex-col": direction === "col",
    "flex-col-reverse": direction === "col-reverse",
    "flex-row space-y-3 -space-x-3": direction === "diagonal",
  });

  const marginClass = classNames({
    "-mr-4": direction?.startsWith("row"),
    "-mt-4": direction?.startsWith("col"),
  });

  return (
    <div
      className={`flex ${
        direction?.startsWith("col") ? "flex-col" : "flex-row"
      } w-auto items-center justify-end whitespace-nowrap ${className}`}
    >
      <div className={`inline-flex ${directionClass}`}>
        {srcSet && srcSet.length
          ? srcSet?.map((_src, index) => (
              <span
                key={index}
                className={`z-1 rounded-full border-4 border-white ${dimensions} ${avatarClass} ${
                  marginClass || ""
                }`}
              >
                <Avatar url={_src} dimensions="w-full h-full" />
              </span>
            ))
          : null}
        {showGigIcon ? (
          <span
            className={`z-1 rounded-full border-4 border-white ${dimensions} ${avatarClass} ${
              marginClass || ""
            }`}
          >
            <div className="h-full w-full p-1">
              <GigIcon className="z-1 h-full w-full rounded-full" />
            </div>
          </span>
        ) : null}
      </div>
      {total && total - limit >= 1 ? (
        <span
          className={`ml-5 font-serif text-sm font-semibold text-current ${labelClassName}`}
        >
          +{total - limit}
        </span>
      ) : null}
    </div>
  );
};

export default GroupAvatarsComponent;
